import { t } from "ttag";

import { PLUGIN_ADMIN_SETTINGS } from "metabase/plugins";

import { UpsellCta } from "./components/UpsellCta";
import { useUpsellLink } from "./components/use-upsell-link";
import { shouldHideUpsells } from "./should-hide-upsells";

export const UpsellEmbeddingButton = ({
  url,
  campaign,
  location,
  size = "default",
}: {
  url: string;
  campaign: string;
  location: string;
  size?: "default" | "large";
}) => {
  const upsellLink = useUpsellLink({
    url,
    campaign,
    location,
  });

  const { triggerUpsellFlow } = PLUGIN_ADMIN_SETTINGS.useUpsellFlow({
    campaign,
    location,
  });

  if (shouldHideUpsells()) {
    return null;
  }

  return (
    <UpsellCta
      onClick={triggerUpsellFlow}
      buttonText={t`Try for free`}
      url={upsellLink}
      internalLink={undefined}
      onClickCapture={() => {}}
      size={size}
    />
  );
};
